/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const legalRegulatoryEnumsDetectionMethodOptionEnum = {
    InternalAudit: 'InternalAudit',
    ExternalAudit: 'ExternalAudit',
    MonitoringSystem: 'MonitoringSystem',
    SelfIdentifiedByEmployee: 'SelfIdentifiedByEmployee',
    CustomerReport: 'CustomerReport',
    ThirdPartyReport: 'ThirdPartyReport',
    RegulatoryAuthorityNotification: 'RegulatoryAuthorityNotification',
    Other: 'Other',
} as const;

export type LegalRegulatoryEnumsDetectionMethodOptionEnumKey =
    (typeof legalRegulatoryEnumsDetectionMethodOptionEnum)[keyof typeof legalRegulatoryEnumsDetectionMethodOptionEnum];

export type LegalRegulatoryEnumsDetectionMethodOption = LegalRegulatoryEnumsDetectionMethodOptionEnumKey;
